import { Modal } from "antd"
import { Button } from "components"
import { AppOTPInput } from "components/inputs/AppOTPInput"
import { ZIndex } from "constants/zIndex"
import { useEffect, useState } from "react"
import { ILoginWith2FA } from "stores/auth"

type Props = {
  loginResponse: ILoginWith2FA
  verifyAdminEmailOtp: (input: { code: string }) => void
  isVerifying: boolean
  resendCode: () => void
  isResending: boolean
  onDismiss: () => void
}

export const AdminEmailOtpPrompt = ({
  loginResponse,
  verifyAdminEmailOtp,
  isVerifying,
  resendCode,
  isResending,
  onDismiss,
}: Props) => {
  const [otp, setOtp] = useState("")
  const [timer, setTimer] = useState(30)

  const disabled = !otp || otp.length < 6

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const handleResend = () => {
    resendCode()
    setTimer(30)
    setOtp("")
  }

  return (
    <Modal
      open
      footer={null}
      onCancel={onDismiss}
      zIndex={ZIndex.Prompt}
      className="lg:max-w-lg max-w-sm"
    >
      <>
        <div className="bg-white flex flex-col items-center justify-between gap-4 py-4 w-full px-6">
          <div className="text-xl font-circular font-semibold text-padeBlack">
            Email Verification
          </div>
          <div className="text-sm text-center text-padeSubtext font-avenir">
            {loginResponse?.message ||
              "We've sent a one-time authentication code to your email. Please enter the code to continue."}
          </div>

          <div className="w-full px-4 flex justify-center">
            <AppOTPInput
              otp={otp}
              setOtp={setOtp}
              onComplete={(code) => {
                if (!isVerifying) verifyAdminEmailOtp({ code })
              }}
              disabled={isVerifying}
            />
          </div>

          <div className="flex gap-2 text-sm">
            <span>Didn't receive the code?</span>
            <span
              className={`font-semibold font-circular ${
                timer === 0
                  ? "cursor-pointer text-primary500 underline"
                  : "cursor-auto"
              }`}
              onClick={() => {
                if (timer === 0) handleResend()
              }}
            >
              {isResending
                ? "Resending…"
                : timer > 0
                ? `Resend in ${timer}s`
                : "Resend"}
            </span>
          </div>

          <div className="mt-2">
            <Button
              color="primary"
              disabled={disabled || isVerifying}
              onClick={() => verifyAdminEmailOtp({ code: otp })}
            >
              {isVerifying ? "Verifying…" : "Verify code"}
            </Button>
          </div>
        </div>
      </>
    </Modal>
  )
}
